import { TextField, TextFieldProps } from "@mui/material";
import { Dayjs } from "dayjs";

export default function WeekTextField(
  props: TextFieldProps & {
    ownerState?: {
      dayjsValue?: Dayjs;
      formatWeekLabel?: (d: Dayjs) => string;
    };
  }
) {
  const { ownerState, ...rest } = props;
  const { dayjsValue, formatWeekLabel } = ownerState ?? {};

  return <TextField {...rest} value={dayjsValue && formatWeekLabel ? formatWeekLabel(dayjsValue) : ""} />;
}
